import React from "react";
import styled from "styled-components";
import { Timeline_Brand_Update } from "./Timeline_Brand_Update";

const TimelineSeller = styled.div`
    display: grid;
    gap: 0.6rem;
`;

// Displays the Sales owner as one compact previous-to-current change.
export const Timeline_Seller = (props) => {
    return (
        <TimelineSeller>
            <Timeline_Brand_Update event={props.event} t={props.t} />
        </TimelineSeller>
    );
};
